<div class="container" [class.electron]="isElectron" *ngIf="finisedLoading">
  <h1 class="title"><i [className]="'fas ' + icon"></i> {{title}}</h1>
  <div class="builders">
    <ng-content></ng-content>
  </div>
</div>
